import { env } from 'configs/EnvironmentConfig'
import fetch from 'auth/FetchInterceptor'
import { z } from 'zod'
import { Validate } from './SchemaValidation'

const searchSchema = z.object({
  domain: z.number().int().optional(),
  name: z.string().optional(),
})
const emailSchema = z.object({
  domain_setting_id: z.number(),
  username: z.string(),
  password: z.string(),
  name: z.string(),
})

const emailUpdateSchema = z.object({
  name: z.string(),
  password: z.string().optional(),
  force_password_change: z.boolean().optional(),
})

const opmailSchema = z.object({
  active: z.boolean().optional(),
  password: z.string().optional(),
})

const updateSettingSchema = z.object({
  active: z.boolean(),
  catalog_id: z.number().optional(),
})

const numberId = z.number()

const EmailService = {}

EmailService.getDomainSettings = id =>
  fetch({
    url: `${env.EMAIL_ENDPOINT_URL}/api/setting/domain/${Validate(
      numberId,
      id
    )}`,
    method: 'GET',
  })

EmailService.resetSettingDnsRecords = id =>
  fetch({
    url: `${env.EMAIL_ENDPOINT_URL}/api/setting/${Validate(
      numberId,
      id
    )}/reset-dns-records`,
    method: 'PATCH',
  })

EmailService.listSettings = () =>
  fetch({
    url: `${env.EMAIL_ENDPOINT_URL}/api/setting`,
    method: 'GET',
  })

EmailService.listCatalog = () =>
  fetch({
    url: `${env.EMAIL_ENDPOINT_URL}/api/catalog`,
    method: 'GET',
  })

EmailService.updateSetting = (id, data) =>
  fetch({
    url: `${env.EMAIL_ENDPOINT_URL}/api/setting/${Validate(numberId, id)}`,
    method: 'PUT',
    data: Validate(updateSettingSchema, data),
  })

EmailService.refreshSettings = () =>
  fetch({
    url: `${env.EMAIL_ENDPOINT_URL}/api/setting/refresh`,
    method: 'PATCH',
  })

EmailService.getOpmail = () =>
  fetch({
    url: `${env.EMAIL_ENDPOINT_URL}/api/opmail/me`,
    method: 'GET',
  })

EmailService.updateOpmail = ({ password, active }) =>
  fetch({
    url: `${env.EMAIL_ENDPOINT_URL}/api/opmail/me`,
    method: 'PUT',
    data: Validate(opmailSchema, { password, active }),
  })

EmailService.getEmails = data => {
  const { name, domain } = Validate(searchSchema, data)

  return fetch({
    url: `${env.EMAIL_ENDPOINT_URL}/api/email-account?name=${name}&domainId=${domain}`,
    method: 'GET',
  })
}

EmailService.getEmail = id =>
  fetch({
    url: `${env.EMAIL_ENDPOINT_URL}/api/email-account/${id}`,
    method: 'GET',
  })

EmailService.getPlans = () =>
  fetch({
    url: `${env.EMAIL_ENDPOINT_URL}/api/service-plan`,
    method: 'GET',
  })

EmailService.createEmail = data =>
  fetch({
    url: `${env.EMAIL_ENDPOINT_URL}/api/email-account`,
    method: 'POST',
    data: Validate(emailSchema, data),
  })

EmailService.updateEmail = (id, data) =>
  fetch({
    url: `${env.EMAIL_ENDPOINT_URL}/api/email-account/${Validate(
      numberId,
      id
    )}`,
    method: 'PUT',
    data: Validate(emailUpdateSchema, data),
  })

EmailService.deleteEmail = id =>
  fetch({
    url: `${env.EMAIL_ENDPOINT_URL}/api/email-account/${Validate(
      numberId,
      id
    )}`,
    method: 'DELETE',
  })

export default EmailService
